import { ConfirmationModalFooter } from '@/components/ConfirmationModal/Base/Footer';
import { useTranslation } from '@/i18n';
import {
  ButtonV2Props,
  ModalWithoutPortal,
} from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo, useMemo } from 'react';
import styles from './StopIntegrationModal.module.scss';

const cx = classnames.bind(styles);

export type StopIntegrationModalProps = {
  open: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const StopIntegrationModal: FC<StopIntegrationModalProps> = memo(
  ({ open, isLoading, onCancel, onConfirm }) => {
    const { t } = useTranslation();

    const cancelButtonProps: ButtonV2Props = useMemo(
      () => ({
        isSecondary: true,
        isTertiary: true,
        onClick: onCancel,
        size: 'sm',
        isDisabled: isLoading,
        children: t('cancel'),
      }),
      [isLoading, onCancel, t]
    );

    const confirmButtonProps: ButtonV2Props = useMemo(
      () => ({
        color: 'danger',
        isSecondary: !isLoading,
        onClick: onConfirm,
        size: 'sm',
        isLoading,
        children: t('reconciliation_service_setting_stop_button'),
        buttonContainerClassName: cx(styles['stop-button']),
      }),
      [isLoading, onConfirm, t]
    );

    return (
      <ModalWithoutPortal
        className={cx(styles['stop-integration-modal'])}
        open={open}
        onClose={onCancel}
        size='md'
        title={t('reconciliation_service_setting_stop_modal_title')}
        mask
        footer={
          <ConfirmationModalFooter
            cancelButton={cancelButtonProps}
            okButton={confirmButtonProps}
          />
        }
      >
        {t('reconciliation_service_setting_stop_modal_text')}
      </ModalWithoutPortal>
    );
  }
);
StopIntegrationModal.displayName = 'StopIntegrationModal';
